import { clearPhone } from '@/services/string';
import BaseService from '@/services/base_service';

export default class BathService extends BaseService {

    list(params) {
        return new Promise((resolve, reject) => {
            axios.get('/banho', params).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    get(id) {
        return new Promise((resolve, reject) => {
            axios.get('/banho/' + id).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    create(model) {
        return new Promise((resolve, reject) => {
            axios.post('/banho', model).then(response => {
                resolve(response);
            }).catch(e => {
                reject(this.getErrors(e));
            });
        });
    }

    update(model, id) {
        return new Promise((resolve, reject) => {
            axios.put('/banho/' + id, model).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

    delete(id) {
        return new Promise((resolve, reject) => {
            axios.delete('/banho/' + id).then(response => {
                resolve(response);
            }).catch(e => {
                reject(e);
            });
        });
    }

}



// WEBPACK FOOTER //
// ./src/services/bath.js